<template>
  <page>
    <template slot="content">
    <help-content :title="'充電マークが出ない/バッテリー残量が増えない'">
      <template slot="content">
        <div class="text">
          1．接触不良の可能性があります。ご利用状況によって汗や汚れで充電器との接点に錆が発生しやすいです。定期的に本体やバンドを水で洗って清潔な乾いた布で水滴を拭き取ってください。<br><br>
          2．メラミンスポンジ等で接点の汚れを掃除してから充電を試してください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H26_1.png">
        <div class="text">
          3．接点復活剤や5-56等の防錆剤を綿棒に塗り、端子をクリーニングしてください。
        </div>
        <img class="picture" src="../assets/images/q_and_a/H26_2.png">
        <div class="text">
          ※WeBandに内蔵しているバッテリーは消耗品です。バッテリーの容量と寿命は、使用とともに自然に低下します。１～３を実施した上フル充電しても使用時間が著しく短い場合はバッテリー寿命です。
        </div>
      </template>
    </help-content>
    </template>
  </page>
</template>

<script>
  import HelpContent from '@/components/HelpContent'
  import Page from '@/components/Page'

  export default {
    components: {
      HelpContent,
      Page
    },
    mounted () {
      window.scrollTo(0, 0)
    }
  }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Help26.vue